import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import {processesHoverViewModule} from '@app/authorized/project/pipeline/processesHoverView-ang7/processesHoverView.module'
import { MatNativeDateModule } from '@angular/material/core';
import { Utils } from '@src/utils/util';
import {ConfigurationsViewComponent} from './configurationsView'
import {HttpClientModule} from '@angular/common/http';
import { DbmAdditionalOptionsModule } from '@app/shared/components/dbm-components/dbm-additional-options/dbm-additional-options.module';

@NgModule({
    imports: [SharedModule, MatDatepickerModule, MatInputModule, MatNativeDateModule , HttpClientModule,processesHoverViewModule , DbmAdditionalOptionsModule ],
    declarations: [ConfigurationsViewComponent],
    entryComponents: [ConfigurationsViewComponent],
    exports: [ConfigurationsViewComponent],
    providers: [MatDatepickerModule, MatNativeDateModule, Utils]
})
export class ConfigurationsViewModule {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/configurationsView-ang7/configurationsView.module.ts